export default __webpack_public_path__ + "static/media/App-Logo.a93fe978.svg";